export const PracticeName = [
  {
    type: "text",
    name: "practice_name",
    label: "preferences.practiceName",
    validation: { required: "Required" },
  },
];

export const AgentDetails = [
  {
    type: "text",
    name: "agent_id",
    label: "preferences.agentId",
    validation: { required: "Required" },
  },
  {
    type: "text",
    name: "user_name",
    label: "preferences.hmrcUserName",
    validation: { required: "Required" },
  },
];

export const AgentDependsMapper = ["tax_agent", "non_tax_agent"];
